var React = require('react');

function CarrotDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#FF8D00","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M.622 1.657L5.64 6.378l5.017-4.72"}));
}

CarrotDownInline.defaultProps = {"width":"11","height":"7","viewBox":"0 0 11 7"};

module.exports = CarrotDownInline;

CarrotDownInline.default = CarrotDownInline;
